/* eslint-disable */
import React, { useRef, useState, useEffect } from 'react';
import BurgerIcon from 'ui-kit/TableSizeControls/old/icons/burgerIcon';
import ControlItem from './components/ControlItem';
import * as Styled from './styles';

const isIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.includes('MSIE ');
  const trident = ua.includes('Trident/');

  return msie || trident;
};

function useClickedOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      setTimeout(() => {
        handler(event);
      }, 0);
    };

    document.addEventListener('mouseup', listener);
    document.addEventListener('touchend', listener);

    return () => {
      document.removeEventListener('mouseup', listener);
      document.removeEventListener('touchend', listener);
    };
  }, [ref, handler]);
}

function TableColumnControl({ columns, activeColumns, setActiveColumns, isOpen, setIsOpen, isAuditPage }) {
  const [focusedColumn, setFocusedColumn] = useState(1);
  const container = useRef();
  const headerRef = useRef();

  const columnsRefs = columns.reduce((acc, item, index) => ({ ...acc, [index + 1]: useRef(null) }), {});

  const handleOptionChange = (pickedValue, disabled) => {
    if (disabled) return false;
    if (activeColumns.includes(pickedValue)) {
      const newValues = [...activeColumns];
      const idIndex = newValues.indexOf(pickedValue);

      newValues.splice(idIndex, 1);
      setActiveColumns(newValues);
    } else {
      const newValues = [...activeColumns, pickedValue];
      setActiveColumns(newValues);
    }
    setIsOpen(false);
  };

  const toggleIsOpen = () => {
    setIsOpen((prev) => !prev);
  };

  const clickedOutsideCallBack = () => setIsOpen(false);

  useClickedOutside(container, clickedOutsideCallBack);

  const handleNextTab = (firstTabInRound, nextTab, lastTabInRound) => {
    const columnToSelect = focusedColumn === lastTabInRound ? firstTabInRound : nextTab;
    setFocusedColumn(columnToSelect);
    columnsRefs[columnToSelect].current.focus();
  };

  const handleKeyDown = (e) => {
    if (!isOpen) return;
    const tabCount = columns.length;
    if (e.keyCode === 27) {
      headerRef.current?.focus();
      toggleIsOpen();
    }

    if ([38].includes(e.keyCode)) {
      e.preventDefault();
      const last = tabCount;
      const next = focusedColumn - 1;
      handleNextTab(last, next, 1);
    }
    if ([40].includes(e.keyCode)) {
      e.preventDefault();
      const first = 1;
      const next = focusedColumn + 1;
      handleNextTab(first, next, tabCount);
    }
  };

  const handleKeyDownMenu = (e) => {
    if (e.keyCode === 32) {
      e.preventDefault();
      toggleIsOpen();
    }
  };

  useEffect(() => {
    if (!isOpen) return;
    columnsRefs[1].current.focus();
    // eslint-disable-next-line
  }, [isOpen]);

  return (
    <Styled.Wrapper>
      <Styled.Header
        isAuditPage={isAuditPage}
        tabIndex={0}
        onClick={toggleIsOpen}
        onKeyDown={handleKeyDownMenu}
        ref={headerRef}
        id="showTableColumns"
      >
        <BurgerIcon />
        <Styled.HeaderContainer>Show columns</Styled.HeaderContainer>
      </Styled.Header>
      {isOpen && (
        <Styled.List ref={container} isAuditPage={isAuditPage} onKeyDown={handleKeyDown}>
          {columns.map(({ label, value: optionValue, disabled }, index) => (
            <ControlItem
              label={label}
              isChecked={activeColumns.includes(optionValue)}
              handleOptionChange={(value) => handleOptionChange(value, disabled)}
              optionValue={optionValue}
              disabled={isIE() ? false : disabled}
              iEdisabled={disabled}
              columnRef={columnsRefs[index + 1]}
              index={index + 1}
              focusedColumn={focusedColumn}
              setFocusedColumn={setFocusedColumn}
            />
          ))}
        </Styled.List>
      )}
    </Styled.Wrapper>
  );
}

export default TableColumnControl;
